import { useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useContext } from 'react';
import { ApiContext } from '../context/Api';

/**
 * A custom hook that redirects to a valid :lang-prefixed URL when the
 * current URL has none (or an invalid one), falling back to the user's
 * saved language cookie (or the default). Syncing the rendered language to
 * an already-valid :lang param is handled centrally by AnalyticsLayout,
 * which wraps every :lang route.
 */
function useLangParam() {
  const { locales, localesLoaded } = useContext(ApiContext);
  let { lang } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [cookies] = useCookies(['language']);

  useEffect(() => {
    if (!localesLoaded) {
      return;
    }

    const validLanguageCodes = locales.map(l => l.code);
    const isValidLangCode = validLanguageCodes.includes(lang);

    // if there's no language param (or it's not a valid one), redirect to
    // the same URL with a valid language prefix
    if (!lang || !isValidLangCode) {
      let currentLanguage = cookies.language || 'ar';
      if (!validLanguageCodes.includes(currentLanguage)) {
        currentLanguage = 'ar';
      }
      // redirect by prefixing current path with language code
      navigate(`/${currentLanguage}${pathname}`, {
        replace: true,
        relative: false
      });
    }
  }, [localesLoaded, locales, lang, cookies.language, navigate, pathname]);
}
export default useLangParam;
